import React from "react";
import { Route, Routes } from "react-router-dom";
import { SimpleLayout } from "../components/simpleLayout";
import { AtualizarCadastro } from "../pages/atualizarCadastro";

const AtualizarCadastroRoutes = () => {
  return (
    <SimpleLayout>
      <Routes>
        <Route path="*" element={<AtualizarCadastro />} />
      </Routes>
    </SimpleLayout>
  );
};

export { AtualizarCadastroRoutes };
